/*
  Author : Om Athalye
  email: om96athalye@gmail.com
  Bitbucket: https://bitbucket.org/OmAthalye/
*/

const schemes = [
  {
    name: "Aditya BSL Money Manager",
    amc: "Aditya Birla",
    trail1: "0.10",
    trail2: "0.10"
  },
  {
    name: "Aditya BSL Savings",
    amc: "Aditya Birla",
    trail1: "0.10",
    trail2: "0.10"
  },
  {
    name: "Aditya BSL Short Term",
    amc: "Aditya Birla",
    trail1: "0.60",
    trail2: "0.60"
  },
  {
    name: "Axis Banking & PSU Debt",
    amc: "Axis",
    trail1: "0.25",
    trail2: "0.25"
  },
  {
    name: "Axis Bluechip Fund",
    amc: "Axis",
    trail1: "0.95",
    trail2: "0.95"
  },
  {
    name: "Axis Gold",
    amc: "Axis",
    trail1: "0.08",
    trail2: "0.08"
  },
  {
    name: "Axis Long Term Equity",
    amc: "Axis",
    trail1: "0.80",
    trail2: "0.80"
  },
  {
    name: "Axis Midcap",
    amc: "Axis",
    trail1: "1.05",
    trail2: "1.05"
  },
  {
    name: "Axis Short Term",
    amc: "Axis",
    trail1: "0.55",
    trail2: "0.55"
  },
  {
    name: "Axis Treasury Advantage",
    amc: "Axis",
    trail1: "0.30",
    trail2: "0.30"
  },
  {
    name: "DSP Corp Bond Fund",
    amc: "DSP",
    trail1: "0.25",
    trail2: "0.25"
  },
  {
    name: "DSP Mid Cap Fund",
    amc: "DSP",
    trail1: "0.80",
    trail2: "0.80"
  },
  {
    name: "DSP US Flexible Equity",
    amc: "DSP",
    trail1: "0.70",
    trail2: "0.70"
  },
  {
    name: "Edelweiss US Technology Equity FoF",
    amc: "Edelweiss",
    trail1: "0.90",
    trail2: "0.90"
  },
  {
    name: "HDFC S/T Debt",
    amc: "HDFC",
    trail1: "0.30",
    trail2: "0.30"
  },
  {
    name: "ICICI Balanced Advantage",
    amc: "ICICI",
    trail1: "0.85",
    trail2: "0.85"
  },
  {
    name: "ICICI Pru Banking & PSU Debt",
    amc: "ICICI",
    trail1: "0.25",
    trail2: "0.25"
  },
  {
    name: "ICICI Pru Corporate Bond",
    amc: "ICICI",
    trail1: "0.20",
    trail2: "0.20"
  },
  {
    name: "ICICI Pru Credit Risk",
    amc: "ICICI",
    trail1: "0.75",
    trail2: "0.75"
  },
  {
    name: "ICICI Pru Regular Savings",
    amc: "ICICI",
    trail1: "0.95",
    trail2: "0.95"
  },
  {
    name: "ICICI Pru Savings",
    amc: "ICICI",
    trail1: "0.10",
    trail2: "0.05"
  },
  {
    name: "ICICI Pru Technology",
    amc: "ICICI",
    trail1: "0.80",
    trail2: "0.80"
  },
  {
    name: "ICICI Pru Ultra Short Term",
    amc: "ICICI",
    trail1: "0.35",
    trail2: "0.35"
  },
  {
    name: "ICICI Pru US Bluechip Equity",
    amc: "ICICI",
    trail1: "0.60",
    trail2: "0.60"
  },
  {
    name: "Invesco India Contra",
    amc: "Invesco",
    trail1: "1.10",
    trail2: "1.10"
  },
  {
    name: "Invesco India Growth Opportunities",
    amc: "Invesco",
    trail1: "1.20",
    trail2: "1.20"
  },
  {
    name: "Invesco India Tax Plan",
    amc: "Invesco",
    trail1: "1.35",
    trail2: "1.35"
  },
  {
    name: "Invesco India Treasury Advantage",
    amc: "Invesco",
    trail1: "0.25",
    trail2: "0.25"
  },
  {
    name: "Invesco Short Term Fund",
    amc: "Invesco",
    trail1: "0.75",
    trail2: "0.75"
  },
  {
    name: "Kotak Banking & PSU Debt",
    amc: "Kotak",
    trail1: "0.30",
    trail2: "0.30"
  },
  {
    name: "Kotak Dynamic Bond",
    amc: "Kotak",
    trail1: "0.75",
    trail2: "0.75"
  },
  {
    name: "Kotak Flexicap",
    amc: "Kotak",
    trail1: "1.10",
    trail2: "1.10"
  },
  {
    name: "Kotak Gold",
    amc: "Kotak",
    trail1: "0.35",
    trail2: "0.35"
  },
  {
    name: "Kotak Low Duration",
    amc: "Kotak",
    trail1: "0.75",
    trail2: "0.75"
  },
  {
    name: "Kotak Small Cap",
    amc: "Kotak",
    trail1: "1.40",
    trail2: "1.40"
  },
  {
    name: "L&T India Value",
    amc: "L&T",
    trail1: "1.20",
    trail2: "1.20"
  },
  {
    name: "Mirae Asset Large Cap",
    amc: "Mirae",
    trail1: "1.00",
    trail2: "1.00"
  },
  {
    name: "Mirae Asset Savings - Reg Savings",
    amc: "Mirae",
    trail1: "0.70",
    trail2: "0.70"
  },
  {
    name: "Mirae Asset Tax Saver",
    amc: "Mirae",
    trail1: "0.75",
    trail2: "0.75"
  },
  {
    name: "Nippon India Pharma",
    amc: "Nippon",
    trail1: "0.95",
    trail2: "0.95"
  },
  {
    name: "SBI Banking & Financial Services",
    amc: "SBI",
    trail1: "1.25",
    trail2: "1.25"
  },
  {
    name: "SBI Equity Hybrid Fund",
    amc: "SBI",
    trail1: "0.80",
    trail2: "0.80"
  },
  {
    name: "SBI Focused Equity Fund",
    amc: "SBI",
    trail1: "1.00",
    trail2: "1.00"
  },
  {
    name: "SBI Magnum Low Duration",
    amc: "SBI",
    trail1: "0.50",
    trail2: "0.50"
  },
  {
    name: "SBI Magnum Medium Duration",
    amc: "SBI",
    trail1: "0.55",
    trail2: "0.55"
  },
  {
    name: "SBI Magnum Ultra Short Duration",
    amc: "SBI",
    trail1: "0.10",
    trail2: "0.10"
  },
  {
    name: "Sundaram Select Focus",
    amc: "Sundaram",
    trail1: "1.00",
    trail2: "1.00"
  },
];

const documents = [
  {
    id: 1,
    amc: "Axis",
    links: [
      "https://drive.google.com/file/d/1nwmQmXz15QSZlBWb1P8CrDJPQPSCu1ub/view?usp=sharing",
      "https://drive.google.com/file/d/1ag8R_5otoGx6DU1Ghd9Qm6qzjl1y1fF-/view?usp=sharing",
      "https://drive.google.com/file/d/1iKmnrjSC56pLymj6Z13C27g4Ez-Ivxwp/view?usp=sharing",
      "https://drive.google.com/file/d/1LUf6SpUqI355lFNKHKgWpxQgdKLZSQHg/view?usp=sharing"
    ]
  },
  {
    id: 2,
    amc: "Birla Sun Life",
    links: [
      "https://drive.google.com/file/d/1UPB4E5cmlbWrbviZf6f2d60uU0rMOuiP/view?usp=sharing",
      "https://drive.google.com/file/d/15s3JUnOWVfCJWqbfcf68iwu4csJDKuXL/view?usp=sharing",
      "https://drive.google.com/file/d/12ZOqtP3RxX3QZ0NcEn_T3odCrh1veNMy/view?usp=sharing",
      "https://drive.google.com/file/d/1KIbnT1IgwxKgG0qaVrT8GMZdz0La3s3l/view?usp=sharing"
    ]
  },
  {
    id: 3,
    amc: "DSP",
    links: [
      "https://drive.google.com/file/d/1vlb0XPOeFniPhK_SaEymzuUSZxQw-AX4/view?usp=sharing",
      "https://drive.google.com/file/d/1294lwe5dEzht8XveRc2YQ4sWfEtfaJvo/view?usp=sharing",
      "https://drive.google.com/file/d/1HY9zGgK1TmcX-IJqrzk7b8dXMLzf7qq2/view?usp=sharing",
      "https://drive.google.com/file/d/1rgewmx4XQlMKDG9yDz7NDB5Tdt8DiCU9/view?usp=sharing"
    ]
  },
  {
    id: 4,
    amc: "Edelweiss",
    links: [
      "https://drive.google.com/file/d/10jghfSAf3cNgENQal1vJ-6QDKq4uweR9/view?usp=sharing",
      "https://drive.google.com/file/d/1UrOdzEG57DRS2hb7E6fHhU_49L9J8gTs/view?usp=sharing",
      "https://drive.google.com/file/d/11dCJVnt9sEs0sfmiDWalZ8QnRi2LVSry/view?usp=sharing",
      "https://drive.google.com/file/d/1jL44m0YUiNGRDtot6pxiVbdvqZ0UCCai/view?usp=sharing"
    ]
  },
  {
    id: 5,
    amc: "HDFC",
    links: [
      "https://drive.google.com/file/d/1KLh5zPlsI6eU9kfpyi5Ev8zhyb80gQB5/view?usp=sharing",
      "https://drive.google.com/file/d/16sOheokA6cm4e-M2aVrkKIx4zyUgVjN6/view?usp=sharing",
      "https://drive.google.com/file/d/1kHWSW31VkAmY1g7Skr7SbGboNb9QTBds/view?usp=sharing",
      "https://drive.google.com/file/d/1mhYczS1ZcpDouoyxkqT38ceEh_ktYUPt/view?usp=sharing"
    ]
  },
  {
    id: 6,
    amc: "ICICI",
    links: [
      "https://drive.google.com/file/d/1eexlPEVpCMBQTebUTCNJ9WiHQ8Qq_P55/view?usp=sharing",
      "https://drive.google.com/file/d/1Cb6dfxRT85zxorDXQOQKd_pgTfYp3aVQ/view?usp=sharing",
      "https://drive.google.com/file/d/1xtH2DdYRcI5Ik3HTP-j_Qo8eBGtJ9PLK/view?usp=sharing",
      "https://drive.google.com/file/d/1XBp1W1PPXsSXB2kna3QwYLINaEFsmTx-/view?usp=sharing"
    ]
  },
  {
    id: 7,
    amc: "IDFC",
    links: [
      "https://drive.google.com/file/d/1EXWxEJtuN1Mrrncct1t1-PBbGwAcH-B7/view?usp=sharing",
      "https://drive.google.com/file/d/1FJwVKDMxlWk4uqVMDc6kh-5O0hp42tcj/view?usp=sharing",
      "https://drive.google.com/file/d/1c9SaDmPOMjuT7_zhDJB3t3gc2bR0BzFM/view?usp=sharing",
      "https://drive.google.com/file/d/1FOQkz5H5TS9cKmk8bJSAfAdJ1foJoHM6/view?usp=sharing"
    ]
  },
  {
    id: 8,
    amc: "Invesco",
    links: [
      "https://drive.google.com/file/d/1OQSJbVHG7caOJv8aCxAypgvLtkas3RhE/view?usp=sharing",
      "https://drive.google.com/file/d/1OlVgRI-bHbQWcb2CZM4sAkWR67tdR1K7/view?usp=sharing",
      "https://drive.google.com/file/d/1cLJ8IBZv_4exL73j92061MO_FPYyvgOl/view?usp=sharing",
      "https://drive.google.com/file/d/10_3a8Ywi4pBdNrRgsdlZFyAx0Q4jWSS0/view?usp=sharing"
    ]
  },
  {
    id: 9,
    amc: "Kotak",
    links: [
      "https://drive.google.com/file/d/15Dh7V6t7y6ebJ84KOrcSPwMJMCjwpdYF/view?usp=sharing",
      "https://drive.google.com/file/d/1IkFiVVGZerZCsmH3DrGPeo3LYzqSDupL/view?usp=sharing",
      "https://drive.google.com/file/d/1RiuV84D7giwBWByAyeyaB3wtEPGPXQTX/view?usp=sharing",
      "https://drive.google.com/file/d/1fNx2_djiC64htjpdqHRaLOHh60kMacIf/view?usp=sharing"
    ]
  },
  {
    id: 10,
    amc: "L&T",
    links: [
      "https://drive.google.com/file/d/1hc07QUf23y7whZNllnD38xJOqWWIuLOw/view?usp=sharing",
      "https://drive.google.com/file/d/1WznlDoemtTVldp0HrlBIq2lTTGFuaCsu/view?usp=sharing",
      "https://drive.google.com/file/d/1PhhwukMcWVFGNSm6hSiXUqL_4-7l2Bh5/view?usp=sharing",
      "https://drive.google.com/file/d/12_edd2Jj6JTsRv1CL1qGteMH1qmE2dGb/view?usp=sharing"
    ]
  },
  {
    id: 11,
    amc: "Mirae",
    links: [
      "https://drive.google.com/file/d/1uB37MVQuvbTQ91YD83TW3LmmiM1naWhx/view?usp=sharing",
      "https://drive.google.com/file/d/1DKivKG3-kLvRb4gCvFBHADC3ShwqfebL/view?usp=sharing",
      "https://drive.google.com/file/d/1rhNtySs0FKOgz6JfogUT5gJIIQzhV4nB/view?usp=sharing",
      "https://drive.google.com/file/d/1eyZpHdNp1J451DqIplFrZqQHPStCFUqW/view?usp=sharing"
    ]
  },
  {
    id: 12,
    amc: "Motilal Oswal",
    links: [
      "https://drive.google.com/file/d/1enyxd9J7tAOihyIJatXLghza-JEpPLUE/view?usp=sharing",
      "https://drive.google.com/file/d/16eeMV821N-nJR-8O9cg71QSzxMddUtK-/view?usp=sharing",
      "https://drive.google.com/file/d/1ZZhpTChufhqvJshaZeSgKdJbZAiCiygX/view?usp=sharing",
      "https://drive.google.com/file/d/1In-D8X97OKZRFDDHVPgulNsDfMQ4-ppQ/view?usp=sharing"
    ]
  },
  {
    id: 13,
    amc: "Nippon",
    links: [
      "https://drive.google.com/file/d/1fwoK_CwbsL_WsNppWgOXjSQmfxmbXFFN/view?usp=sharing",
      "https://drive.google.com/file/d/1JpQp6N10PBuyseg26e88Abk8B4rgXTCz/view?usp=sharing",
      "https://drive.google.com/file/d/1RjOQR29rDTY7y0obm-qm9qk7T_g-doW4/view?usp=sharing",
      "https://drive.google.com/file/d/1tDglTSwyAA9uGmQ66VQE5BXlng9BjN3Y/view?usp=sharing"
    ]
  },
  {
    id: 14,
    amc: "SBI",
    links: [
      "https://drive.google.com/file/d/1_c-gnp1LXSvWycHomS-L47JgkilvNWPk/view?usp=sharing",
      "https://drive.google.com/file/d/169sRF2bJd4ycOomPFidYpESiQ2zW7D3Y/view?usp=sharing",
      "https://drive.google.com/file/d/18GG4jdkM9TS449jpDI7Mma-B-OLMx8iN/view?usp=sharing",
      "https://drive.google.com/file/d/1fAXK2iN3mrQdyJ2FbcTHu0UWaEZR2X7g/view?usp=sharing"
    ]
  },
  {
    id: 15,
    amc: "Sundaram",
    links: [
      "https://drive.google.com/file/d/1fyqDBL5kFMohyPVDBZ_Agqz47dBs-x31/view?usp=sharing",
      "https://drive.google.com/file/d/1zZ5AoIkP1pGgn3SlWL0t_9MDR0LoNyLC/view?usp=sharing",
      "https://drive.google.com/file/d/17iu_cjL-UXp9uySP4d2DuBoKW50tnhCk/view?usp=sharing",
      "https://drive.google.com/file/d/1WJfuQ3a2iURFZsjc6ynKFpvNNyxGou3w/view?usp=sharing"
    ]
  },
  {
    id: 16,
    amc: "Tata",
    links: [
      "https://drive.google.com/file/d/16pS0qFX5ygxAd4p3UNgauV5VWcNANn9p/view?usp=sharing",
      "https://drive.google.com/file/d/14DNoP1x_WMgian7klICAVJXAz5OJcIDV/view?usp=sharing",
      "https://drive.google.com/file/d/1nRJDPpW4Mpc00WpaSWmiJ5nrtnEaH1d9/view?usp=sharing",
      "https://drive.google.com/file/d/1SagYQBnUKOnzI-afgUzSTYQVcvYQhzrZ/view?usp=sharing"
    ]
  },
  {
    id: 17,
    amc: "UTI",
    links: [
      "https://drive.google.com/file/d/1RGCuOViKXaj0r1pFXGAXZQZHYGTY6uVM/view?usp=sharing",
      "https://drive.google.com/file/d/1H-03isMYo608899LU2u-VYhu7qLenSgj/view?usp=sharing",
      "https://drive.google.com/file/d/16-HezocjO0E5uN08If6p7IhEoKdLMCsw/view?usp=sharing",
      "https://drive.google.com/file/d/1GckM_S44PJL5qhq80A-2iVPm4ZCjk6sg/view?usp=sharing"
    ]
  }
];

export {
  schemes,
  documents,
}